import { useSelector } from 'react-redux'

import { selectIsInternalAdmin } from '../../../accessors'
import campaignNames, {
  campaignNamesForInternalAdmin,
  campaignsDescriptions
} from '../../../main/campaignNamesAndDesc'

export function useCampaignName(key) {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const name = isInternalAdmin
    ? campaignNamesForInternalAdmin[key] || key
    : campaignNames[key] || key

  const desc = campaignsDescriptions[key] || ''

  return [name, desc]
}
